export default "__VITE_ASSET__Vx1z70eU__"